// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const ClipboardPassIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 48 48">
    <g fill="currentColor">
      <path d="M30.1 15.76h-7.4a.3.3 0 0 0-.3.3v1.72c0 .17.13.3.3.3h7.4a.3.3 0 0 0 .3-.3v-1.72a.3.3 0 0 0-.3-.3M30.1 28.5h-7.4a.3.3 0 0 0-.3.3v1.72c0 .17.13.3.3.3h7.4a.3.3 0 0 0 .3-.3V28.8a.3.3 0 0 0-.3-.3M18.66 26.14a1.2 1.2 0 0 0-1.66 0L15.14 28l-1.88-1.86a1.2 1.2 0 0 0-1.66 0 1.2 1.2 0 0 0 0 1.64l1.88 1.88-1.88 1.88a1.2 1.2 0 0 0 0 1.64 1.2 1.2 0 0 0 1.66 0l1.88-1.88L17 33.18a1.18 1.18 0 0 0 2-.82 1.1 1.1 0 0 0-.34-.82l-1.88-1.88 1.88-1.88a1.14 1.14 0 0 0 0-1.64M17.66 14l-4.12 4.1-1.44-1.44a1.14 1.14 0 0 0-1.64 0 1.2 1.2 0 0 0 0 1.66l2.2 2.26q.34.33.82.34.48-.01.84-.34l4.92-4.92a1.2 1.2 0 0 0 0-1.66 1.14 1.14 0 0 0-1.58 0" />
      <path d="M34.12 4.64H29V4.2A3.2 3.2 0 0 0 25.8 1H15.52a3.2 3.2 0 0 0-3.2 3.2v.44H7.2A3.2 3.2 0 0 0 4 7.84v30A3.2 3.2 0 0 0 7.2 41h26.92a3.2 3.2 0 0 0 3.2-3.2v-30a3.2 3.2 0 0 0-3.2-3.16m-19.2-.44a.6.6 0 0 1 .6-.6H25.8a.6.6 0 0 1 .6.6v3.44a.6.6 0 0 1-.6.6H15.52a.6.6 0 0 1-.6-.6zm19.74 33.6a.6.6 0 0 1-.6.6H7.2a.6.6 0 0 1-.6-.6v-30a.6.6 0 0 1 .6-.6h5.12v.4a3.2 3.2 0 0 0 3.2 3.2H25.8A3.2 3.2 0 0 0 29 7.6v-.4h5.12a.6.6 0 0 1 .6.6z" />
    </g>
    <path fill="#292928" d="M31 34h11v9H31z" />
    <path
      fill="currentColor"
      d="M36.66 30a8 8 0 1 0 0 16 8 8 0 0 0 0-16m-1.6 12-4-4 1.13-1.13 2.87 2.87 6.07-6.08 1.13 1.14z"
    />
  </svg>,
  "ClipboardPass",
);
export default ClipboardPassIcon;
